module.exports = __webpack_public_path__ + "static/import3-min-8175f6ca59630c3058873f987de466bd.png";